import { lazyLoad } from 'utils/loadable';

export const BannerFormPage = lazyLoad(
  () => import('./index'),
  module => module.BannerFormPage,
);
